export const icons: Record<string, string> = {
  APP39: "https://static.cybozu.com/contents/k/image/icon/app/appTableBlue.png",
  APP62: "https://static.cybozu.com/contents/k/image/icon/app/document.png",
  APP47: "https://static.cybozu.com/contents/k/image/icon/app/bargraph.png",
  APP69: "https://static.cybozu.com/contents/k/image/icon/app/laptop.png",
  APP61: "https://static.cybozu.com/contents/k/image/icon/app/disk.png",
  APP50: "https://static.cybozu.com/contents/k/image/icon/app/calculator.png",
  APP55: "https://static.cybozu.com/contents/k/image/icon/app/clipboard.png",
  APP82: "https://static.cybozu.com/contents/k/image/icon/app/printer.png",
  APP48: "https://static.cybozu.com/contents/k/image/icon/app/binder.png",
  APP56: "https://static.cybozu.com/contents/k/image/icon/app/clock.png",
  APP64: "https://static.cybozu.com/contents/k/image/icon/app/fileholder.png",
  APP89: "https://static.cybozu.com/contents/k/image/icon/app/userpass.png",
  APP75: "https://static.cybozu.com/contents/k/image/icon/app/openmail.png",
  APP72: "https://static.cybozu.com/contents/k/image/icon/app/mail.png",
  APP79: "https://static.cybozu.com/contents/k/image/icon/app/piegraph.png",
  APP70: "https://static.cybozu.com/contents/k/image/icon/app/linegraph.png",
  APP59: "https://static.cybozu.com/contents/k/image/icon/app/cup.png",
  APP81: "https://static.cybozu.com/contents/k/image/icon/app/pin.png",
  APP54: "https://static.cybozu.com/contents/k/image/icon/app/clip.png",
  APP84: "https://static.cybozu.com/contents/k/image/icon/app/smartphone.png",
  APP86: "https://static.cybozu.com/contents/k/image/icon/app/telephone.png",
  APP49: "https://static.cybozu.com/contents/k/image/icon/app/businessbag.png",
  APP51: "https://static.cybozu.com/contents/k/image/icon/app/calendar.png",
  APP73: "https://static.cybozu.com/contents/k/image/icon/app/megaphone.png",
  APP77: "https://static.cybozu.com/contents/k/image/icon/app/pencil.png",
  APP74: "https://static.cybozu.com/contents/k/image/icon/app/mouse.png",
  APP65: "https://static.cybozu.com/contents/k/image/icon/app/flash.png",
  APP63: "https://static.cybozu.com/contents/k/image/icon/app/equipment.png",
  APP90: "https://static.cybozu.com/contents/k/image/icon/app/wallet.png",
  APP80: "https://static.cybozu.com/contents/k/image/icon/app/piggybank.png",
  APP58: "https://static.cybozu.com/contents/k/image/icon/app/creditcard.png",
  APP76: "https://static.cybozu.com/contents/k/image/icon/app/payment.png",
  APP68: "https://static.cybozu.com/contents/k/image/icon/app/glasses.png",
  APP85: "https://static.cybozu.com/contents/k/image/icon/app/soroban.png",
  APP52: "https://static.cybozu.com/contents/k/image/icon/app/cashbox.png",
  APP60: "https://static.cybozu.com/contents/k/image/icon/app/diamond.png",
  APP46: "https://static.cybozu.com/contents/k/image/icon/app/balloon.png",
  APP87: "https://static.cybozu.com/contents/k/image/icon/app/thinkingballoon.png",
  APP88: "https://static.cybozu.com/contents/k/image/icon/app/tool.png",
  APP57: "https://static.cybozu.com/contents/k/image/icon/app/cloudup.png",
  APP67: "https://static.cybozu.com/contents/k/image/icon/app/gear.png",
  APP71: "https://static.cybozu.com/contents/k/image/icon/app/lock.png",
  APP53: "https://static.cybozu.com/contents/k/image/icon/app/chemistry.png",
  APP83: "https://static.cybozu.com/contents/k/image/icon/app/research.png",
  APP66: "https://static.cybozu.com/contents/k/image/icon/app/gasstation.png",
  APP78: "https://static.cybozu.com/contents/k/image/icon/app/percent.png",
  APP3: "https://static.cybozu.com/contents/k/image/icon/app/appItem.png",
  APP18: "https://static.cybozu.com/contents/k/image/icon/app/appSupport.png",
  APP20: "https://static.cybozu.com/contents/k/image/icon/app/appUserList.png",
  APP26: "https://static.cybozu.com/contents/k/image/icon/app/appCalendar.png",
};

export const getKintoneIconUrl = (iconKey?: string | null): string | undefined => {
  if (!iconKey) {
    return undefined;
  }
  return icons[iconKey.toUpperCase()];
};
